export const referDomains = [{
        name: '双德',
        value: "app.sungdell.com"
    },
    {
        name: '纸圭',
        value: "zhigui.sungdell.com"
    },
    {
        name: '头条',
        value: "toutiao.sungdell.com"
    },
    {
        name: '百度',
        value: "baidu.sungdell.com"
    },
];

export const orderTypes = [
    {name: '展示(6天)', value: '展示'},
    {name: '商城(6天)', value: '商城'},
    {name: '查询(6天)', value: '查询'},
    {name: '游戏账号交易(6天)', value: '游戏账号交易'},
    {name: '知识付费(7天)', value: '知识付费'},
    {name: '预订系统(7天)', value: '预订系统'},
    {name: '考试系统(7天)', value: '考试系统'},
    {name: '功能定制(7天)', value: '功能定制'},
    {name: '模板(6天)', value: '模板'},
    {name: '设计稿(10天)', value: '设计稿'},
];

export const languages = [{
    "name": "英语",
    "value": "en"
}, {
    "name": "中文",
    "value": "cn"
}, {
    "name": "日语",
    "value": "ja"
}, {
    "name": "西班牙",
    "value": "es"
}, {
    "name": "法语",
    "value": "fr"
}, {
    "name": "俄语",
    "value": "ru"
}, {
    "name": "越南语",
    "value": "vi"
}, {
    "name": "韩国",
    "value": "ko"
}, {
    "name": "印尼语",
    "value": "id"
}, {
    "name": "马来语",
    "value": "ms"
}, {
    "name": "德语",
    "value": "de"
}, {
    "name": "阿拉伯语",
    "value": "ar"
}, {
    "name": "葡萄牙语",
    "value": "pt"
}, {
    "name": "波斯语",
    "value": "fa"
}, {
    "name": "希腊语",
    "value": "el"
}, {
    "name": "匈牙利语",
    "value": "hu"
}, {
    "name": "波兰语",
    "value": "pl"
}, {
    "name": "捷克语",
    "value": "cs"
}, {
    "name": "泰语",
    "value": "th"
}, {
    "name": "高棉语",
    "value": "km"
}, {
    "name": "印地语",
    "value": "hi"
}, {
    "name": "意大利",
    "value": "it"
}, {
    "name": "冰岛语",
    "value": "is"
}, {
    "name": "孟加拉语",
    "value": "bn"
}, {
    "name": "荷兰语",
    "value": "nl"
}, {
    "name": "罗马尼亚语",
    "value": "ro"
}, {
    "name": "缅甸语",
    "value": "my"
}, {
    "name": "哈萨克语",
    "value": "kk"
}, {
    "name": "瑞典语",
    "value": "sv"
}, {
    "name": "克罗地亚语",
    "value": "hr"
}, {
    "name": "土耳其语",
    "value": "tr"
}, {
    "name": "老挝语",
    "value": "lo"
}];


// WEBPACK FOOTER //
// ./src/util/consts.js